import React from 'react';
import { connect } from 'react-redux';
import { addStep } from '../actions';

let AddStep = ({
  dispatch
}) => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      dispatch(addStep());
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-outline-success btn-sm mt-1"
  }, "Add Step")));
};

AddStep = connect()(AddStep);
export default AddStep;